import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './../../core/services/authentication.service';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NavItem } from './../../core/interfaces/navItem';
import { Global } from 'src/app/core/resources/global';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { version } from 'package.json';
import { FirebaseApi } from 'src/app/core/classes/firebase-api';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { environment } from 'src/environments/environment';
import { MasterTestingMenuDialogComponent } from 'src/app/shared/master-testing-menu-dialog/master-testing-menu-dialog.component';
import { Companies } from 'src/app/core/resources/companies';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicFirebaseService } from 'src/app/core/services/dynamic-firebase.service';
import { Permission } from 'src/app/core/resources/permission';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { RolesService } from 'src/app/modules/administration/roles/roles.service';
import { error } from 'console';
import { Utils } from 'src/app/core/resources/utils';
import { StorageService } from 'src/app/core/services/storage.service';
import { MinistryMonitorService } from 'src/app/core/services/ministry-monitor.service';
import { MinistryMonitor } from 'src/app/core/interfaces/ministry-monitor';
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

  public environment = environment;
  menu: NavItem[];
  activeNav: string;
  userName: string;
  onNavigationEnd: any;
  message;
  showNavResponsive: boolean = false;
  firebaseUserUnsubscribe;
  firebaseRoleUnsubscribe;
  private activeMenuSub: Subscription;
  isAbleToGetUser: boolean = false;
  isAbleToGetRole: boolean = false;
  currentRole: string;
  currentRoleId: string;
  @Input() orientation: string;
  version: string;
  permission = Permission;
  rndcStatus: MinistryMonitor | null = null;
  private rndcStatusSub?: Subscription;

  get rndcAllUp(): boolean {
    return !!(this.rndcStatus && this.rndcStatus.stateChannel1 && this.rndcStatus.stateChannel2 && this.rndcStatus.stateChannelPLC);
  }
  get rndcAllDown(): boolean {
    return !!(this.rndcStatus && !this.rndcStatus.stateChannel1 && !this.rndcStatus.stateChannel2 && !this.rndcStatus.stateChannelPLC);
  }
  get rndcPartialUp(): boolean {
    return !!(this.rndcStatus && !this.rndcAllUp && !this.rndcAllDown);
  }

  constructor(
    private router: Router,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef,
    public global: Global,
    private modalService: NgbModal,
    public dialog: MatDialog,
    public spinner: NgxSpinnerService,
    public dynamicService: DynamicFirebaseService,
    private snackbarService: SnackBarService,
    public rolesService: RolesService,
    private ministryMonitorService: MinistryMonitorService,
  ) {
    this.menu = this.global.menu;
    this.onNavigationEnd = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => {
        return e;
      })
    );
  }

  ngOnInit() {
    this.validateSession();
    this.version = version;
    if (this.authService && this.authService.sessionActive()) {
      this.ministryMonitorService.startListener();
      this.rndcStatusSub = this.ministryMonitorService.currentStatus$.subscribe(status => {
        this.rndcStatus = status;
      });
    }
  }

  validateSession() {
    if (this.authService && this.authService.sessionActive()) {
      if (this.authService.getUserSession().information.name) {
        this.userName = this.authService.getUserSession().information.name.split(" ")[0];
        if (this.authService.getUserSession().role) this.currentRole = this.authService.getUserSession().role;
        if (this.authService.getUserSession().information.document) this.subscribeToUserChanges(this.authService.getUserSession().information.document);
        if (this.authService.getUserSession().roleId) {
          this.currentRoleId = this.authService.getUserSession().roleId;
          this.subscribeToRoleChanges(this.authService.getUserSession().roleId);
        }
      }
    } else {
      this.userName = "";
    }
    this.cdRef.detectChanges();
    this.subscribeActiveMenu();
  }

  async subscribeToUserChanges(document: string) {

    this.isAbleToGetUser = false;
    if (this.firebaseUserUnsubscribe) this.firebaseUserUnsubscribe();
    try {
      const doc = await FirebaseApi.firestore.collection('UserClient').doc(document).get();
      if (doc.exists) {
        this.firebaseUserUnsubscribe = FirebaseApi.firestore.collection('UserClient').doc(document).onSnapshot((snapshot) => {
          if (snapshot.exists) {
            let currentUser = snapshot.data();
            if (!this.isAbleToGetUser) this.isAbleToGetUser = true;
            else if (currentUser && currentUser.roleId && currentUser.role && currentUser.roleId !== this.currentRoleId) {
              this.currentRole = currentUser.role;
              this.currentRoleId = currentUser.roleId;
              this.changesOnPermissionsMessage(`Se te ha asignado el Rol de ${this.currentRole}, ¿Deseas recargar para obtener los nuevos permisos?`);
              this.subscribeToRoleChanges(this.currentRoleId);
            }
          }
        });
      }
    } catch (e) { }
  }

  async subscribeToRoleChanges(roleId: string) {

    this.isAbleToGetRole = false;
    if (this.firebaseRoleUnsubscribe) this.firebaseRoleUnsubscribe();
    try {
      const doc = await FirebaseApi.firestore.collection('Rol').doc(roleId).get();
      if (doc.exists) {
        // Fix: el listener de Rol debe guardarse en firebaseRoleUnsubscribe (no en
        // firebaseUserUnsubscribe) para no pisar la referencia del listener de usuario
        // y poder desuscribir ambos. Antes ambos listeners quedaban colgados al cambiar de rol.
        this.firebaseRoleUnsubscribe = FirebaseApi.firestore.collection('Rol').doc(roleId).onSnapshot((snapshot) => {
          if (snapshot.exists) {
            if (!this.isAbleToGetRole) this.isAbleToGetRole = true;
            else {
              this.changesOnPermissionsMessage(`Se te han asignado nuevos permisos, ¿Deseas recargar para obtenerlos?`);
            }
          }
        });
      }
    } catch (e) { }
  }

  changesOnPermissionsMessage(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: message,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        window.location.reload();
      }
    });
  }

  subscribeActiveMenu() {
    // Sin query string: las rutas del menú no lo llevan (p. ej. ?transportCompanyId=).
    this.activeNav = window.location.hash.substring(1).split('?')[0];
    this.activeMenuSub = this.onNavigationEnd.subscribe(arg => {
      if (arg && arg.url) {
        this.activeNav = arg.url.split('?')[0];
      }
    });
  }

  refreshDataCompanyOthersComponents() {
    switch (this.router.url) {
      case '/validation':
        break;
      case '/documents':

        break;
    }
  }

  openOptionsProfile(tooltip: any) {
    if (tooltip.isOpen()) {
      tooltip.close();
    } else {
      tooltip.open();
    }
  }

  openModalConfirmLogOut(modal) {
    this.modalService.open(modal, { keyboard: false, centered: true, ariaLabelledBy: 'modal-basic-title' });
  }

  closeModalConfirmLogOut() {
    this.modalService.dismissAll();
  }

  async logOut() {
    this.spinner.show();
    const response = await this.authService.attemptLogout();
    this.closeModalConfirmLogOut();
    if (!response) return this.spinner.hide();;
    this.userName = '';
    try {
      await this.dynamicService.deleteAllFirebaseInstances();
    } catch { }
  }



  openMasterTools() {
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.EXTRA_SMALL_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    this.dialog.open(MasterTestingMenuDialogComponent, config);
  }

  viewDocuments() {
    this.router.navigate(['/documents']);
  }

  changePassword() {
    this.router.navigate(['/password']);
  }

  onOpen(item: NavItem) {
    item.expanded = true;
  }

  onClose(item: NavItem) {
    item.expanded = false;
  }

  navigateTo(url: string, openInNewTab: boolean = false) {
    if (openInNewTab) {
      window.open(`/#${url}`, '_blank');
    } else {
      this.router.navigate([url]);
    }
    this.showNavResponsive = !this.showNavResponsive;
  }

  onClickItemMenu(itemChildren: NavItem, item: NavItem) {
    if (itemChildren.route) {
      this.router.navigate([itemChildren.route]);
      item.expanded = false;
    } else if (itemChildren.displayName === 'Cerrar sesión') {
      this.closeModalConfirmLogOut();
    }
    this.showNavResponsive = !this.showNavResponsive;
  }

  isItemActive(item: NavItem): boolean {
    return item && item.childrens && item.childrens.some(itemChildren => this.activeNav === itemChildren.route);
  }

  canBeShown(permission: NavItem): boolean {
    if (!this.authService) return false;
    return this.authService && Companies.companiesAccess(permission.route, this.authService.getUserSession().clientCompanyId, StorageService.checkStorage().getItem('_companyId'));
  }

  expansionPanelHeader(navItem: NavItem) {
    if ((!navItem.childrens || navItem.childrens.length === 0) && navItem.route) {
      this.router.navigate([navItem.route]);
    }
  }

  toggleNavResponsive() {
    this.showNavResponsive = !this.showNavResponsive;
  }

  rootAppUser() {
    const email = this.authService.getUserSession().email;
    return email.includes('loggiapp') || email.includes('teclogi');
  }

  ngOnDestroy() {
    if (this.firebaseUserUnsubscribe) this.firebaseUserUnsubscribe();
    if (this.firebaseRoleUnsubscribe) this.firebaseRoleUnsubscribe();
    if (this.activeMenuSub) this.activeMenuSub.unsubscribe();
    if (this.rndcStatusSub) this.rndcStatusSub.unsubscribe();
    this.cdRef.detach();
  }

  async openFintechApp() {
    this.spinner.show();
    try {
      if (!this.authService || !this.authService.getUserSession() || !this.authService.getUserSession().roleId) throw new Error('RoleId of the current user not provided');
      await this.authService.redirectToLoggiCash();
    } catch (error) {
      console.error(error)
      this.snackbarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    } finally {
      this.spinner.hide();
    }
  }

  async openSealsApp() {
    window.open(`${environment.urlSealsApp}`, '_blank');
  }

  async openRNDCStatus() {
    this.router.navigate(['/monitoring/rndc-status']);
  }
}